import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../../models/prototype-route-id';

export const projectNorthStarNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.project_north_star_integrated_people_view, {
      displayName: 'Integrated people view',
      icon: SolIcon.users,
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
